import { InjectionToken } from '@angular/core';

export const CALCULATOR_COMPONENT_TOKEN = new InjectionToken('CALCULATOR_COMPONENT_TOKEN');
